import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/typography';
import type { QrLinkProps } from '@modules/dashboard/pages/docs-verification/docs-verification-page/qr-link/types';
import { QRCodeSVG } from 'qrcode.react';

import { QrLinkContainer } from './styles';

export const QrLink: React.FC<QrLinkProps> = ({ link, className }) => {
    const { t } = useTranslation();

    return (
        <QrLinkContainer className={className}>
            <div className='qr-code'>
                <QRCodeSVG value={link} size={80} />
            </div>

            <div className='main'>
                <Typography tag='h4' variant='text-bold' className='qr-link__title'>
                    {t('docVerificationWidget.qrLink.title')}
                </Typography>
                <Typography tag='div' variant='small-text' className='qr-link__text'>
                    {t('docVerificationWidget.qrLink.text')}
                </Typography>
            </div>
        </QrLinkContainer>
    );
};
